import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

// Gera PDF de um encontro específico
export const gerarPDFEncontro = (encontro, celula, membros, getMembro) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  
  // Cores do tema
  const primaryColor = [212, 160, 48]; // Âmbar dourado
  const secondaryColor = [45, 75, 115]; // Azul profundo
  const textColor = [50, 50, 50];
  
  // Header
  doc.setFillColor(...primaryColor);
  doc.rect(0, 0, pageWidth, 35, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(24);
  doc.setFont('helvetica', 'bold');
  doc.text('FORJADORES', 14, 18);
  
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text('Comunidade de Fé', 14, 26);
  
  // Data do relatório
  doc.setFontSize(9);
  doc.text(`Gerado em: ${format(new Date(), "dd/MM/yyyy 'às' HH:mm")}`, pageWidth - 14, 26, { align: 'right' });
  
  let yPos = 50;
  
  // Título do Encontro
  doc.setTextColor(...secondaryColor);
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text(`${encontro.livro}${encontro.capitulo ? ` - Capítulo ${encontro.capitulo}` : ''}`, 14, yPos);
  
  yPos += 10;
  
  // Info do Célula
  doc.setTextColor(...textColor);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  doc.text(`Célula: ${celula?.nome || 'Não especificado'}`, 14, yPos);
  
  yPos += 8;
  
  // Data e Local
  const dataFormatada = format(new Date(encontro.data), "EEEE, dd 'de' MMMM 'de' yyyy", { locale: ptBR });
  doc.text(`Data: ${dataFormatada}`, 14, yPos);
  yPos += 6;
  doc.text(`Horário: ${encontro.horario}`, 14, yPos);
  yPos += 6;
  doc.text(`Local: ${encontro.local}`, 14, yPos);
  
  yPos += 6;
  const pregador = getMembro(encontro.pregador);
  doc.text(`Pregador: ${pregador?.nome || 'A definir'}`, 14, yPos);
  
  yPos += 6;
  doc.text(`Status: ${encontro.status === 'realizado' ? 'Realizado' : 'Agendado'}`, 14, yPos);
  
  yPos += 12;
  
  // Assuntos
  if (encontro.assuntos && encontro.assuntos.length > 0) {
    doc.setFillColor(245, 245, 245);
    doc.rect(14, yPos - 4, pageWidth - 28, 8 + (encontro.assuntos.length * 6), 'F');
    
    doc.setTextColor(...secondaryColor);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.text('Assuntos Abordados:', 18, yPos + 2);
    
    yPos += 10;
    doc.setTextColor(...textColor);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    encontro.assuntos.forEach((assunto) => {
      doc.text(`• ${assunto}`, 22, yPos);
      yPos += 6;
    });
    
    yPos += 6;
  }
  
  // Cronograma
  if (encontro.cronograma && encontro.cronograma.length > 0) {
    doc.setTextColor(...secondaryColor);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.text('Cronograma do Encontro', 14, yPos);
    
    yPos += 8;
    
    const cronogramaData = encontro.cronograma.map(item => {
      const responsaveis = item.responsaveis
        .map(id => getMembro(id)?.nome || 'A definir')
        .join(', ');
      return [
        `${item.horaInicio} - ${item.horaFim}`,
        item.atividade,
        responsaveis || '-'
      ];
    });
    
    autoTable(doc, {
      startY: yPos,
      head: [['Horário', 'Atividade', 'Responsável(is)']],
      body: cronogramaData,
      theme: 'striped',
      headStyles: {
        fillColor: secondaryColor,
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        fontSize: 10
      },
      bodyStyles: {
        fontSize: 9,
        textColor: textColor
      },
      alternateRowStyles: {
        fillColor: [250, 248, 245]
      },
      columnStyles: {
        0: { cellWidth: 35 },
        1: { cellWidth: 80 },
        2: { cellWidth: 'auto' }
      },
      margin: { left: 14, right: 14 }
    });
    
    yPos = doc.lastAutoTable.finalY + 12;
  }
  
  // Lista de Presença (se realizado)
  if (encontro.status === 'realizado' && (encontro.presentes.length > 0 || encontro.ausentes.length > 0)) {
    // Verifica se precisa de nova página
    if (yPos > 220) {
      doc.addPage();
      yPos = 20;
    }
    
    doc.setTextColor(...secondaryColor);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.text('Lista de Presença', 14, yPos);
    
    yPos += 8;
    
    const presencaData = [];
    
    encontro.presentes.forEach(membroId => {
      const membro = getMembro(membroId);
      if (membro) {
        presencaData.push([membro.nome, membro.papel, '✓ Presente']);
      }
    });
    
    encontro.ausentes.forEach(membroId => {
      const membro = getMembro(membroId);
      if (membro) {
        presencaData.push([membro.nome, membro.papel, '✗ Ausente']);
      }
    });
    
    if (presencaData.length > 0) {
      autoTable(doc, {
        startY: yPos,
        head: [['Nome', 'Papel', 'Status']],
        body: presencaData,
        theme: 'striped',
        headStyles: {
          fillColor: secondaryColor,
          textColor: [255, 255, 255],
          fontStyle: 'bold',
          fontSize: 10
        },
        bodyStyles: {
          fontSize: 9,
          textColor: textColor
        },
        alternateRowStyles: {
          fillColor: [250, 248, 245]
        },
        margin: { left: 14, right: 14 }
      });
      
      yPos = doc.lastAutoTable.finalY + 8;
    }
    
    // Resumo
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...textColor);
    doc.text(`Total de Presentes: ${encontro.presentes.length}`, 14, yPos + 4);
    doc.text(`Total de Ausentes: ${encontro.ausentes.length}`, 80, yPos + 4);
    
    yPos += 12;
  }
  
  // Observações
  if (encontro.observacoes) {
    // Verifica se precisa de nova página
    if (yPos > 240) {
      doc.addPage();
      yPos = 20;
    }
    
    doc.setTextColor(...secondaryColor);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.text('Observações:', 14, yPos);
    
    yPos += 8;
    doc.setTextColor(...textColor);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    
    const splitObservacoes = doc.splitTextToSize(encontro.observacoes, pageWidth - 28);
    doc.text(splitObservacoes, 14, yPos);
  }
  
  // Footer
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text(
      `"Onde dois ou três estiverem reunidos em meu nome, ali estou eu no meio deles." - Mateus 18:20`,
      pageWidth / 2,
      doc.internal.pageSize.getHeight() - 10,
      { align: 'center' }
    );
    doc.text(
      `Página ${i} de ${pageCount}`,
      pageWidth - 14,
      doc.internal.pageSize.getHeight() - 10,
      { align: 'right' }
    );
  }
  
  // Salvar
  const nomeArquivo = `encontro_${celula?.nome || 'celula'}_${encontro.data}.pdf`.replace(/\s+/g, '_').toLowerCase();
  doc.save(nomeArquivo);
};

// Gera PDF de todos os encontros de um celula
export const gerarPDFCelula = (celula, encontros, getMembro) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  
  // Cores do tema
  const primaryColor = [212, 160, 48];
  const secondaryColor = [45, 75, 115];
  const textColor = [50, 50, 50];
  
  // Header
  doc.setFillColor(...primaryColor);
  doc.rect(0, 0, pageWidth, 40, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(24);
  doc.setFont('helvetica', 'bold');
  doc.text('FORJADORES', 14, 18);
  
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text('Comunidade de Fé', 14, 26);
  
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text(`Relatório do Célula: ${celula.nome}`, 14, 35);
  
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text(`Gerado em: ${format(new Date(), "dd/MM/yyyy 'às' HH:mm")}`, pageWidth - 14, 35, { align: 'right' });
  
  let yPos = 55;
  
  // Informações do Célula
  doc.setTextColor(...secondaryColor);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text('Informações do Célula', 14, yPos);
  
  yPos += 10;
  doc.setTextColor(...textColor);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  
  doc.text(`Líder: ${celula.lider || 'Não definido'}`, 14, yPos);
  yPos += 6;
  doc.text(`Dia dos Encontros: ${celula.diaSemana} às ${celula.horario}`, 14, yPos);
  yPos += 6;
  doc.text(`Local: ${celula.endereco}${celula.cidade ? ` - ${celula.cidade}` : ''}`, 14, yPos);
  yPos += 6;
  doc.text(`Total de Membros: ${celula.membros.length}`, 14, yPos);
  yPos += 6;
  doc.text(`Total de Encontros: ${encontros.length}`, 14, yPos);
  
  yPos += 12;
  
  // Objetivo
  if (celula.objetivo) {
    doc.setFillColor(250, 248, 245);
    const objetivoSplit = doc.splitTextToSize(celula.objetivo, pageWidth - 36);
    const objetivoHeight = objetivoSplit.length * 5 + 14;
    doc.rect(14, yPos - 4, pageWidth - 28, objetivoHeight, 'F');
    
    doc.setTextColor(...secondaryColor);
    doc.setFont('helvetica', 'bold');
    doc.text('Objetivo:', 18, yPos + 2);
    
    yPos += 8;
    doc.setTextColor(...textColor);
    doc.setFont('helvetica', 'normal');
    doc.text(objetivoSplit, 18, yPos);
    
    yPos += objetivoHeight - 6;
  }
  
  // Princípios e Metas
  if (celula.principios?.length > 0 || celula.metas?.length > 0) {
    yPos += 8;
    
    if (celula.principios?.length > 0) {
      doc.setTextColor(...secondaryColor);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(11);
      doc.text('Princípios:', 14, yPos);
      yPos += 6;
      
      doc.setTextColor(...textColor);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      doc.text(celula.principios.map(p => `• ${p}`).join('   '), 14, yPos);
      yPos += 10;
    }
    
    if (celula.metas?.length > 0) {
      doc.setTextColor(...secondaryColor);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(11);
      doc.text('Metas:', 14, yPos);
      yPos += 6;
      
      doc.setTextColor(...textColor);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      celula.metas.forEach(meta => {
        doc.text(`✓ ${meta}`, 18, yPos);
        yPos += 5;
      });
      yPos += 5;
    }
  }
  
  // Lista de Encontros
  yPos += 8;
  doc.setTextColor(...secondaryColor);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text('Histórico de Encontros', 14, yPos);
  
  yPos += 8;
  
  if (encontros.length > 0) {
    const encontrosData = encontros
      .sort((a, b) => b.data.localeCompare(a.data))
      .map(encontro => {
        const pregador = getMembro(encontro.pregador);
        return [
          format(new Date(encontro.data), 'dd/MM/yyyy'),
          `${encontro.livro}${encontro.capitulo ? ` ${encontro.capitulo}` : ''}`,
          pregador?.nome || 'A definir',
          encontro.status === 'realizado' ? 'Realizado' : 'Agendado',
          encontro.status === 'realizado' ? `${encontro.presentes.length}/${encontro.presentes.length + encontro.ausentes.length}` : '-'
        ];
      });
    
    autoTable(doc, {
      startY: yPos,
      head: [['Data', 'Estudo', 'Pregador', 'Status', 'Presença']],
      body: encontrosData,
      theme: 'striped',
      headStyles: {
        fillColor: secondaryColor,
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        fontSize: 9
      },
      bodyStyles: {
        fontSize: 8,
        textColor: textColor
      },
      alternateRowStyles: {
        fillColor: [250, 248, 245]
      },
      columnStyles: {
        0: { cellWidth: 25 },
        1: { cellWidth: 55 },
        2: { cellWidth: 40 },
        3: { cellWidth: 25 },
        4: { cellWidth: 22 }
      },
      margin: { left: 14, right: 14 }
    });
    
    yPos = doc.lastAutoTable.finalY + 15;
  } else {
    doc.setTextColor(...textColor);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'italic');
    doc.text('Nenhum encontro registrado.', 14, yPos);
    yPos += 15;
  }
  
  // Detalhes de cada encontro (se houver espaço ou nova página)
  encontros
    .sort((a, b) => b.data.localeCompare(a.data))
    .forEach((encontro, index) => {
      // Nova página para cada encontro detalhado
      if (index > 0 || yPos > 200) {
        doc.addPage();
        yPos = 20;
      }
      
      // Título do encontro
      doc.setFillColor(...secondaryColor);
      doc.rect(14, yPos - 5, pageWidth - 28, 12, 'F');
      
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text(`${encontro.livro}${encontro.capitulo ? ` - Capítulo ${encontro.capitulo}` : ''} | ${format(new Date(encontro.data), 'dd/MM/yyyy')}`, 18, yPos + 3);
      
      yPos += 15;
      
      // Detalhes
      doc.setTextColor(...textColor);
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      
      const pregador = getMembro(encontro.pregador);
      doc.text(`Horário: ${encontro.horario} | Local: ${encontro.local}`, 14, yPos);
      yPos += 5;
      doc.text(`Pregador: ${pregador?.nome || 'A definir'} | Status: ${encontro.status === 'realizado' ? 'Realizado' : 'Agendado'}`, 14, yPos);
      
      yPos += 8;
      
      // Assuntos
      if (encontro.assuntos?.length > 0) {
        doc.setFont('helvetica', 'bold');
        doc.text('Assuntos:', 14, yPos);
        yPos += 5;
        doc.setFont('helvetica', 'normal');
        doc.text(encontro.assuntos.map(a => `• ${a}`).join('  '), 18, yPos);
        yPos += 8;
      }
      
      // Cronograma
      if (encontro.cronograma?.length > 0) {
        doc.setFont('helvetica', 'bold');
        doc.text('Cronograma:', 14, yPos);
        yPos += 5;
        
        const cronogramaData = encontro.cronograma.map(item => {
          const responsaveis = item.responsaveis
            .map(id => getMembro(id)?.nome || 'A definir')
            .join(', ');
          return [
            `${item.horaInicio} - ${item.horaFim}`,
            item.atividade,
            responsaveis || '-'
          ];
        });
        
        autoTable(doc, {
          startY: yPos,
          head: [['Horário', 'Atividade', 'Responsável(is)']],
          body: cronogramaData,
          theme: 'grid',
          headStyles: {
            fillColor: primaryColor,
            textColor: [255, 255, 255],
            fontStyle: 'bold',
            fontSize: 8
          },
          bodyStyles: {
            fontSize: 8,
            textColor: textColor
          },
          columnStyles: {
            0: { cellWidth: 30 },
            1: { cellWidth: 70 },
            2: { cellWidth: 'auto' }
          },
          margin: { left: 14, right: 14 }
        });
        
        yPos = doc.lastAutoTable.finalY + 8;
      }
      
      // Observações
      if (encontro.observacoes) {
        doc.setFont('helvetica', 'bold');
        doc.text('Observações:', 14, yPos);
        yPos += 5;
        doc.setFont('helvetica', 'normal');
        const obsLines = doc.splitTextToSize(encontro.observacoes, pageWidth - 32);
        doc.text(obsLines, 18, yPos);
        yPos += obsLines.length * 4 + 8;
      }
      
      // Presença
      if (encontro.status === 'realizado') {
        doc.setFont('helvetica', 'bold');
        doc.text(`Presença: ${encontro.presentes.length} presentes, ${encontro.ausentes.length} ausentes`, 14, yPos);
        yPos += 10;
      }
    });
  
  // Footer em todas as páginas
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text(
      `"Onde dois ou três estiverem reunidos em meu nome, ali estou eu no meio deles." - Mateus 18:20`,
      pageWidth / 2,
      doc.internal.pageSize.getHeight() - 10,
      { align: 'center' }
    );
    doc.text(
      `Página ${i} de ${pageCount}`,
      pageWidth - 14,
      doc.internal.pageSize.getHeight() - 10,
      { align: 'right' }
    );
  }
  
  // Salvar
  const nomeArquivo = `relatorio_${celula.nome}_${format(new Date(), 'yyyy-MM-dd')}.pdf`.replace(/\s+/g, '_').toLowerCase();
  doc.save(nomeArquivo);
};
